<ng-container>
  <mat-form-field>
    <input  [ngModel]="startDate" name="startDate" id="{{id}}-startDate"
      (ngModelChange)="setStartDate($event)" #startDateInput
      [matDatepicker]="startDatePicker" matInput
      [min]="minDate" [max]="maxStartDate"
      [placeholder]="startDateLabel">
    <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
    @if (!validStartDate) {
      <mat-error>
        {{'Invalid date.' | translate}}
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <input  [ngModel]="endDate" name="endDate" id="{{id}}-endDate"
      (ngModelChange)="setEndDate($event)"
      [min]="minEndDate" type="text" #endDateInput
      [matDatepicker]="endDatePicker" matInput
      [placeholder]="endDateLabel">
    <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
    @if (!datesInOrder) {
      <mat-error>
        {{datesNotInOrderError}}
      </mat-error>
    }
    @if (!validEndDate) {
      <mat-error>
        {{'Invalid date.' | translate}}
      </mat-error>
    }
  </mat-form-field>
</ng-container>
